<template>
  <div>
    <page-title color="lips">Enrollment Reports</page-title>
    <async-loader v-if="reportsLoading"/>
    <template v-else>
      <report-section
        :reports="computedEnrollmentReports"/>
    </template>
  </div>
</template>
<script>
  import ReportSection from './EnrollmentReport/SingleReport.vue'
  import PageTitle from './EnrollmentReport/PageTitle'
  import reporting from '@mixins/reporting'
  import fetchable from '@mixins/fetchable'

  export default {
    mixins: [fetchable, reporting],
    components: {
      PageTitle,
      ReportSection
    },
    computed: {
      computedEnrollmentReports () {
        if (this.reportTypes && this.reportTypes[0] && this.reportTypes[0].enrollReports) { return this.reportTypes[0].enrollReports } else return []
      }
    },
    data() {
      return {
        fetchers: [
          {
            action: 'reporting/GET_REPORTS',
            options: {
              params: {
                type: 'EN'
              }
            }
          }
        ]
      }
    }
  }
</script>
